<template>
  <div class="RightDeals">
    <div class="container-flued">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h3>
              Get In Touch,<br />
              We’d Love To Hear From You
            </h3>
          </div>
          <div class="col-lg-2"></div>
          <div class="col-lg-8">
            <form>
              <div class="form-group">
                <label for="exampleInputEmail1">Full Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  aria-describedby="emailHelp"
                  placeholder="Enter Name"
                  v-model="name"
                />
                <div class="alert alert-danger" v-if="nameErrorMsg !== ''">
                  {{ nameErrorMsg }}
                </div>
                <!-- <small id="emailHelp" class="form-text text-muted"
                  >We'll never share your email with anyone else.</small
                > -->
              </div>
              <div class="form-group">
                <label for="exampleInputEmail1">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="email"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                />
                <div class="alert alert-danger" v-if="emailErrorMsg !== ''">
                  {{ emailErrorMsg }}
                </div>
                <!-- <small id="emailHelp" class="form-text text-muted"
                  >We'll never share your email with anyone else.</small
                > -->
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Phone</label>
                <input
                  type="number"
                  class="form-control"
                  id="exampleInputPassword1"
                  placeholder="Enter Phone"
                />
              </div>
              <div class="form-group">
                <label for="message">Example textarea</label>
                <textarea
                  class="form-control"
                  id="message"
                  rows="3"
                  v-model="message"
                ></textarea>
                <div class="alert alert-danger" v-if="messageErrorMsg !== ''">
                  {{ messageErrorMsg }}
                </div>
              </div>
              <!-- <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="exampleCheck1"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >Check me out</label
                >
              </div> -->
              <div class="form-group">
                <div class="alert alert-success" v-if="apiResponse !== ''">
                  {{ apiResponse }}
                </div>
                <button
                  type="submit"
                  @click.prevent="validate()"
                  class="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-2"></div>
        </div>
        <!--/row-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ContactForm',
  props: {
    msg: String,
  },
  data() {
    return {
      name: '',
      email: '',
      message: '',
      nameErrorMsg: '',
      emailErrorMsg: '',
      messageErrorMsg: '',
      apiResponse: '',
    };
  },
  methods: {
    goto(selectedName) {
      this.$router.push({ name: selectedName, replace: true });
    },
    validate() {
      let error = 0;
      if (this.name == '') {
        error = error + 1;
        this.nameErrorMsg = 'Name is required.';
        document.getElementById('name').style.border = '1px solid red';
        document.getElementById('name').style.borderRadius = '0px';
      } else {
        this.nameErrorMsg = '';
        document.getElementById('name').style.border = '0px';
        document.getElementById('name').style.borderRadius = '0px';
      }
      if (this.email == '') {
        error = error + 1;
        this.emailErrorMsg = 'Email is required.';
        document.getElementById('email').style.border = '1px solid red';
        document.getElementById('email').style.borderRadius = '0px';
      } else {
        this.emailErrorMsg = '';
        document.getElementById('email').style.border = '0px';
        document.getElementById('email').style.borderRadius = '0px';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.email)) {
          error = error + 1;
          this.emailErrorMsg = 'Please enter a valid email address';
          document.getElementById('email').style.border = '1px solid red';
          document.getElementById('email').style.borderRadius = '0px';
        } else {
          this.emailErrorMsg = '';
          document.getElementById('email').style.border = '0px';
          document.getElementById('email').style.borderRadius = '0px';
        }
      }

      if (this.message == '') {
        error = error + 1;
        this.messageErrorMsg = 'Message is required.';
        document.getElementById('message').style.border = '1px solid red';
        document.getElementById('message').style.borderRadius = '0px';
      } else {
        this.messageErrorMsg = '';
        document.getElementById('message').style.border = '0px';
        document.getElementById('message').style.borderRadius = '0px';
      }
      if (error == 0) {
        axios
          .post('https://allleadsprovider.com/sendEmail.php', {
            name: this.name,
            email: this.email,
            phone: this.phone,
            message: this.message,
          })
          .then(response => {
            if (response.data == 'success') {
              this.apiResponse =
                'Thanks for contacting us. We will reach to you soon!';
            }
            //this.apiResponse = response.data;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.RightDeals {
  background: #dbdade;
  padding-bottom: 40px;
  padding-top: 40px;
  .form-group {
    margin-top: 20px;
    label {
      color: #292341;
      font-family: Inter;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    .alert {
      color: red;
      font-weight: 300;
      padding: 5px 10px;
      border-radius: 0px;
    }
  }
  .form-control:focus {
    border-color: rgba(226, 184, 66, 0.91);
    outline: 0;
    box-shadow: none;
  }
  .btn-primary {
    background-color: rgba(226, 184, 66, 0.91);
    border-color: rgba(226, 184, 66, 0.91);
    width: 100%;
    color: #292341;
    margin-bottom: 80px;
  }
  h3 {
    color: #292341;
    font-family: Inter;
    font-size: 48px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    margin-top: 40px;
  }
  h4 {
    color: #292341;
    font-family: Inter;
    font-size: 36px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  h5 {
    color: #fff;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: inline-block;
    margin-left: 20px;
  }
  .zCard {
    margin: 20px;
    border-radius: 8px;
    border: 1px solid rgba(0, 52, 120, 0.26);
    background: #73717b;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    box-sizing: border-box;
    cursor: pointer;
    img {
      display: inline-block;
    }
    h5 {
      color: #292341;
      font-family: Open Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.96px;
      text-transform: uppercase;
    }
    p {
      color: #fff;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: 0.72px;
      text-transform: capitalize;
      margin-top: 10px;
    }
    a {
      border-radius: 8px;
      border: 2px solid #ffc93c;
      color: #fff;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding: 4px 12px;
      text-decoration: none;
    }
  }
}
@media screen and (max-width: 1300px) {
  .RightDeals {
    h3 {
      font-size: 24px;
    }
    h4 {
      font-size: 24px;
    }
    h5 {
      font-size: 18px;
    }
  }
}
@media screen and (max-width: 992px) {
  .RightDeals {
    h3 {
      padding-top: 5px;
      padding-bottom: 5px;
      text-align: left;
    }
    h4 {
      padding-top: 5px;
      padding-bottom: 5px;
    }
    h5 {
      padding-top: 5px;
      padding-bottom: 5px;
    }
  }
}
</style>
